import React, { useState } from "react";
import { set } from "dot-prop-immutable";
import { connect } from "react-redux";
import moment from 'moment';
import { getParentElementWithChildren, getParentFormWidthChildren } from "@whalecloud/page-builder-core/selectors";
import { toolFormAttr, toolCollapseAttr, getLocale, getTypeArr, handleInputType } from '@utils/util';
import { SimpleForm as Form, Collapse, Switch, Select } from '@whalecloud/fdx';
import CommonItemSettings from '@whalecloud/page-builder-base-components/components/ElementSettings/CommonItemSettings';
import CommonDateSettings from '@whalecloud/page-builder-base-components/components/ElementSettings/CommonDateSettings';

const { Panel } = Collapse;
const { Option } = Select;

const valueKey = 'data.formItemSettings';
const formKey = 'data.formSettings';

const frommatObj = {
  date: 'YYYY-MM-DD',
  time: 'YYYY-MM-DD HH:mm:ss',
  month: 'YYYY-MM',
  year: 'YYYY'
}

const DatePickerSettings = (props: any) => {
  const messages = getLocale();

  const { updateElement, activateElement, parentElement, element, formElement } = props;
  const { data: { formItemSettings = {}, formSettings = {} } = {}, type, id  } = element;
  if (!formSettings || !(formSettings?.name)) {
    const newElement = set(element, `${formKey}.name`, `${type}_${id}`);
    updateElement({
      element: newElement,
    });
  }

  const {
    picker = 'date',
    showToday = true,
    showTime,
  } = formItemSettings;

  const initialValues = {
    picker: showTime ? 'time' : picker,
    showToday,
  };

  const [dateMode, setDateMode] = useState(initialValues.picker)
  const [format, setFormat] = useState(frommatObj[initialValues.picker])
  const [pickerShowNow, setShowNow] = useState(showTime)

  const onFormChange = (obj: Object) => {
    Object.keys(obj).forEach((key: string) => {
      const propName = `${valueKey}.${key}`;
      let value = obj[key];
      let newElement = element;
      if (key === 'type') {
        const getHandle = handleInputType(element, propName, value, parentElement, valueKey, formKey);
        newElement = getHandle?.newElement;
        if (getHandle?.getElement) activateElement({ element: getHandle?.getElement?.id });
      } else if (key === 'picker') {
        setDateMode(value);
        setFormat(frommatObj[value])
        newElement = set(newElement, `${valueKey}.format`, frommatObj[value]);
        if (value === 'time') {
          newElement = set(newElement, `${valueKey}.showTime`, true);
          newElement = set(newElement, `${valueKey}.showToday`, false);
          value = 'date'
          setShowNow(true)
        } else {
          newElement = set(newElement, `${valueKey}.showTime`, false);
          setShowNow(false)
        }
      } else if(key === 'showToday') {
        let showTodayValue = {
          value: moment().format(formItemSettings.format),
          format,
        };
        if (!value) {
          showTodayValue = {};
        }
        handleInitialValues(formSettings.name, showTodayValue);
      }
      newElement = set(newElement, propName, value);
      updateElement({
        element: newElement,
      });
    });
  };

  const handleInitialValues = (name, value) => {
    if (formElement) {
      const propName = `data.formSettings.initialValues.${name}`
      const newElement = set(formElement, propName, value);
      updateElement({
        element: newElement,
      });
    }
  }

  return (
    <Collapse {...toolCollapseAttr} defaultActiveKey={['1']}>
      <Panel header={messages['PAGEBUIDER_SETTINGS']} key="1">
        <CommonItemSettings />
        <Form {...toolFormAttr} initialValues={initialValues} onValuesChange={onFormChange}>
          <Form.Item label={messages['PAGEBUIDER_SETTINGS_DATE_STATUS']} name="picker">
            <Select>
              <Option value="date">{messages['PAGEBUIDER_SETTINGS_DATE']}</Option>
              <Option value="time">{messages['PAGEBUIDER_SETTINGS_DATE_TIME']}</Option>
              <Option value="month">{messages['PAGEBUIDER_SETTINGS_MONTH']}</Option>
              <Option value="year">{messages['PAGEBUIDER_SETTINGS_YEAR']}</Option>
            </Select>
          </Form.Item>
          {dateMode === 'date' && (<Form.Item label={messages['PAGEBUIDER_SETTINGS_SHOW_TODAY']} name="showToday" valuePropName="checked">
            <Switch />
          </Form.Item>)}
        </Form>
        <CommonDateSettings pickerFormat={format} pickerShowNow={pickerShowNow} />
      </Panel>
    </Collapse>
  );
};

const mapDispatchToProps = (dispatch: any) => ({
  activateElement: (payload: any) => {
    dispatch({
      type: 'ui/activateElement',
      payload,
    });
  },
});

export default connect<any, any, any>(
  (state, { element }) => {
    return { 
      parentElement: getParentElementWithChildren(state, element.id),
      formElement: getParentFormWidthChildren(state, element.id)
    }
  },
  mapDispatchToProps,
)(React.memo(DatePickerSettings));
